<template>
  <div class="component-card">
    <j-title-header :options="title"/>

    <div class="d-flex m__b--20">
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'general'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('general')">
        GENERAL
      </div>
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'pembina'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('pembina')">
        PEMBINA
      </div>
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'anggota'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('anggota')">
        ANGGOTA
      </div>
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'agenda'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('agenda')">
        AGENDA
      </div>
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'nilai'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('nilai')">
        NILAI
      </div>
      <!-- <div
        :class="{'tab-experience-manager-active' : tabSelected === 'surat'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('surat')">
        SURAT
      </div> -->
    </div>

    <div v-if="tabSelected === 'general'">
      <b-form-group :class="{'error-input' : $v.data_master.kode.$error}">
        <label> Kode </label>
        <j-input
          v-model="$v.data_master.kode.$model"
          :disabled="true"
          placeholder="Kode"/>
      </b-form-group>
      <b-form-group :class="{'error-input' : $v.data_master.name.$error}">
        <label> Name </label>
        <j-input
          v-model="$v.data_master.name.$model"
          :disabled="readOnly"
          placeholder="Name"/>
      </b-form-group>
      <b-form-group :class="{'error-input' : $v.data_master.status.$error}">
        <label> Status </label>
        <j-single-select
          v-model="$v.data_master.status.$model"
          :options="list_status_ekskul"
          :disabled="readOnly"
          placeholder="Pilih Status"
          label="name"/>
      </b-form-group>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteDataEkskul">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateDataEkskul">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="$router.replace('/data-ekskul')">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
    <div v-if="tabSelected === 'pembina'">
      <v-client-table
        :data="list_pembina"
        :columns="columns_pembina"
        :options="options_pembina"
        class="jTable"
        @row-click="openEditModalPembina">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              v-if="!readOnly"
              class="btn grey btn-import-form m__r--5"
              @click="$refs.modalCreatePembina.show()">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
          </b-form>
        </div>
      </v-client-table>
    </div>
    <div v-if="tabSelected === 'anggota'">
      <b-row>
        <b-col md="3">
          <b-form-group :class="{'error-input' : $v.tahunajaranAnggota.$error}">
            <label> Tahun Ajaran </label>
            <j-single-select
              v-model="$v.tahunajaranAnggota.$model"
              :options="list_tahun_ajaran"
              :placeholder="'Pilih Tahun Ajaran'"
              value-format="object"
              label="tahunajaran"/>
          </b-form-group>
        </b-col>
        <b-col md="9">
          <b-button
            :disabled="!tahunajaranAnggota"
            class="btn blue m__t--27"
            @click="listAnggota(tahunajaranAnggota.tahunajaran)">
            Cari
          </b-button>
        </b-col>
      </b-row>

      <v-client-table
        :data="list_anggota"
        :columns="columns_anggota"
        :options="options_anggota"
        class="jTable"
        @row-click="openEditModalAnggota">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              v-if="!readOnly"
              class="btn grey btn-import-form m__r--5"
              @click="$refs.modalCreateAnggota.show()">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
            <j-import-file-oos
              v-if="openImportAnggota && !readOnly && tahunajaranAnggota"
              :href-sample="require('@/assets/file/FORMAT_IMPORT_EKSKUL_ANGGOTA.zip')"
              class="import-style"
              @import-data="importDataAnggota"/>
            <div class="cc-btn">
              <b-button
                v-if="is_error_anggota"
                class="btn outline red"
                @click="$refs.editAnggota.show()">
                <i class="fa fa-close"/>
                Open Error Data
              </b-button>
            </div>
          </b-form>
        </div>
      </v-client-table>

      <j-progress-screen
        ref="ImportFileAnggota"
        :data-kirim="data_import_anggota"
        :url-api="'ekskul/siswa/create'"
        :headers="headers"
        @finish="reloadPageAnggota"/>

      <b-modal
        ref="editAnggota"
        class="mod-form"
        centered>
        <h3 class="float-to-center c--red">
          Error Data
        </h3>
        <v-client-table
          v-if="error_data_anggota[0]"
          :data="error_data_anggota"
          :columns="columns_error_anggota"
          :options="options_error_anggota"
          class="jTable">

          <div
            slot="ERROR"
            slot-scope="props">
            <div
              v-for="(err, index) in props.row.ERROR"
              :key="index">
              {{ err }}
            </div>
          </div>

        </v-client-table>
        <download-excel
          :data="error_data_anggota"
          class="float-to-right m__t--30"
          name="data-error.xls">
          <b-button class="btn green">
            Export Error
          </b-button>
        </download-excel>
      </b-modal>
    </div>
    <div v-if="tabSelected === 'agenda'">
      <v-client-table
        :data="list_agenda"
        :columns="columns"
        :options="options"
        class="jTable"
        @row-click="openEditModalAgenda">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              v-if="!readOnly"
              class="btn grey btn-import-form m__r--5"
              @click="$refs.modalCreate.show()">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
          </b-form>
        </div>
      </v-client-table>
    </div>
    <div v-if="tabSelected === 'nilai'">
      <b-row>
        <b-col md="3">
          <b-form-group :class="{'error-input' : $v.tahun_ajaran_nilai.$error}">
            <label> Tahun Ajaran </label>
            <j-single-select
              v-model="$v.tahun_ajaran_nilai.$model"
              :options="list_tahun_ajaran"
              :placeholder="'Pilih Tahun Ajaran'"
              value-format="object"
              label="tahunajaran"/>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group :class="{'error-input' : $v.semester_nilai.$error}">
            <label> Semester </label>
            <j-single-select
              v-model="$v.semester_nilai.$model"
              :options="list_semester"
              :placeholder="'Pilih Semester'"
              value-format="object"
              label="name"/>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-button
            :disabled="!tahun_ajaran_nilai || !semester_nilai"
            class="btn blue m__t--27"
            @click="listNilaiAnggota">
            Cari
          </b-button>
        </b-col>
      </b-row>

      <j-import-file-oos
        v-if="openImportNilai && !readOnly && tahun_ajaran_nilai && semester_nilai"
        :href-sample="require('@/assets/file/FORMAT_IMPORT_EKSKUL_NILAI.zip')"
        class="import-style"
        @import-data="importDataNilai"/>
      <div class="cc-btn">
        <b-button
          v-if="is_error_nilai"
          class="btn outline red"
          @click="$refs.editNilai.show()">
          <i class="fa fa-close"/>
          Open Error Data
        </b-button>
      </div>

      <div
        v-for=" (item, index) in list_siswa_nilai"
        :key="index"
        class="list-nilai">
        <b-row>
          <b-col
            md="7"
            class="p__t--10">
            {{ item.nis }} <br>
            {{ item.nama_siswa }}
          </b-col>
          <b-col md="5">
            <j-single-select
              v-model="item.nilai"
              :options="list_nilai"
              :placeholder="'Pilih Nilai'"
              :disabled="readOnly"
              class="p__t--10"
              label="name"/>
          </b-col>
        </b-row>
      </div>
      <b-button
        v-if="list_siswa_nilai.length > 0 && !readOnly"
        class="btn grey btn-import-form m__r--5"
        @click="actionInsertNilai">
        {{ modeUpdateNilai ? 'Update' : 'Insert' }}
      </b-button>

      <j-progress-screen
        ref="ImportFileNilai"
        :data-kirim="data_import_nilai"
        :url-api="'ekskul/nilai/create'"
        :headers="headers"
        @finish="reloadPageNilai"/>

      <b-modal
        ref="editNilai"
        class="mod-form"
        centered>
        <h3 class="float-to-center c--red">
          Error Data
        </h3>
        <v-client-table
          v-if="error_data_nilai[0]"
          :data="error_data_nilai"
          :columns="columns_error_nilai"
          :options="options_error_nilai"
          class="jTable">

          <div
            slot="ERROR"
            slot-scope="props">
            <div
              v-for="(err, index) in props.row.ERROR"
              :key="index">
              {{ err }}
            </div>
          </div>

        </v-client-table>
        <download-excel
          :data="error_data_nilai"
          class="float-to-right m__t--30"
          name="data-error.xls">
          <b-button class="btn green">
            Export Error
          </b-button>
        </download-excel>
      </b-modal>
    </div>
    <div v-if="tabSelected === 'surat'">
      <v-server-table
        v-show="load_first"
        ref="tableServer"
        :columns="columns_surat"
        :options="options_surat"
        class="jTable"
        @loading="loading"
        @loaded="loaded"
        @row-click="openEditModalSurat">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              v-if="!readOnly"
              class="btn grey btn-import-form m__r--5"
              @click="$refs.modalCreateSurat.show();
                      showAdditionalInfo = true;">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
          </b-form>
        </div>
      </v-server-table>
      <jLoadingTable v-if="!load_first"/>
    </div>

    <!-- Pembina -------------------------------------------------------------------- -->
    <b-modal
      ref="modalCreatePembina"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Insert Pembina</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_pembina.tahunajaran.$error}">
            <label> Tahun Ajaran </label>
            <j-single-select
              v-model="$v.data_pembina.tahunajaran.$model"
              :options="list_tahun_ajaran"
              :placeholder="'Pilih Tahun Ajaran'"
              value-format="object"
              label="tahunajaran"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_pembina.kode_pegawai.$error}">
            <label> Pembina </label>
            <j-single-select
              v-model="$v.data_pembina.kode_pegawai.$model"
              :options="list_pegawai"
              :placeholder="'Pilih Pembina'"
              value-format="object"
              label="name"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveDataPembina">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreatePembina">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdatePembina"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Detail Pembina</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_pembina.tahunajaran.$error}">
            <label> Tahun Ajaran </label>
            <j-single-select
              v-model="$v.data_pembina.tahunajaran.$model"
              :options="list_tahun_ajaran"
              :placeholder="'Pilih Tahun Ajaran'"
              :disabled="readOnly"
              value-format="object"
              label="tahunajaran"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_pembina.kode_pegawai.$error}">
            <label> Pembina </label>
            <j-single-select
              v-model="$v.data_pembina.kode_pegawai.$model"
              :options="list_pegawai"
              :placeholder="'Pilih Pembina'"
              :disabled="readOnly"
              value-format="object"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_pembina.notes.$error}">
            <label> Notes </label>
            <j-textarea
              v-model="$v.data_pembina.notes.$model"
              :disabled="readOnly"
              placeholder="Notes"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteDataPembina">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateDataPembina">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdatePembina">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Anggota -------------------------------------------------------------------- -->
    <b-modal
      ref="modalCreateAnggota"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Insert Anggota</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_anggota.tahunajaran.$error}">
            <label> Tahun Ajaran </label>
            <j-single-select
              v-model="$v.data_anggota.tahunajaran.$model"
              :options="list_tahun_ajaran"
              :placeholder="'Pilih Tahun Ajaran'"
              value-format="object"
              label="tahunajaran"
              @getData="getDataKelas"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_anggota.kode_kelas.$error}">
            <label> Kelas </label>
            <j-single-select
              v-model="$v.data_anggota.kode_kelas.$model"
              :options="list_kelas"
              :placeholder="'Pilih Kelas'"
              :disabled="!data_anggota.tahunajaran"
              value-format="object"
              label="name"
              @getData="getDataSiswa"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_anggota.nis.$error}">
            <label> Anggota </label>
            <j-single-select
              v-model="$v.data_anggota.nis.$model"
              :options="list_siswa_by_kelas"
              :placeholder="'Pilih Anggota'"
              :disabled="!data_anggota.kode_kelas"
              value-format="object"
              label="name"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveDataAnggota">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreateAnggota">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdateAnggota"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Detail Anggota</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_anggota.tahunajaran.$error}">
            <label> Tahun Ajaran </label>
            <j-single-select
              v-model="$v.data_anggota.tahunajaran.$model"
              :options="list_tahun_ajaran"
              :placeholder="'Pilih Tahun Ajaran'"
              :disabled="readOnly"
              value-format="object"
              label="tahunajaran"
              @getData="getDataKelas"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_anggota.kode_kelas.$error}">
            <label> Kelas </label>
            <j-single-select
              v-model="$v.data_anggota.kode_kelas.$model"
              :options="list_kelas"
              :placeholder="'Pilih Kelas'"
              :disabled="!data_anggota.tahunajaran || readOnly"
              value-format="object"
              label="name"
              @getData="getDataSiswa"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_anggota.nis.$error}">
            <label> Anggota </label>
            <j-single-select
              v-model="$v.data_anggota.nis.$model"
              :options="list_siswa_by_kelas"
              :placeholder="'Pilih Anggota'"
              :disabled="!data_anggota.kode_kelas || readOnly"
              value-format="object"
              label="name"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteDataAnggota">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateDataAnggota">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdateAnggota">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Agenda -------------------------------------------------------------------- -->
    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Agenda</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_agenda.tahunajaran.$error}">
            <label> Tahun Ajaran </label>
            <j-single-select
              v-model="$v.data_agenda.tahunajaran.$model"
              :options="list_tahun_ajaran"
              :placeholder="'Pilih Tahun Ajaran'"
              value-format="object"
              label="tahunajaran"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_agenda.semester.$error}">
            <label> Semester </label>
            <j-single-select
              v-model="$v.data_agenda.semester.$model"
              :options="list_semester"
              :placeholder="'Pilih Semester'"
              value-format="object"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_agenda.date_time.$error}">
            <label> Tanggal </label>
            <j-datepicker
              v-model="$v.data_agenda.date_time.$model"
              placeholder="Tanggal"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_agenda.description.$error}">
            <label> Deskripsi </label>
            <j-textarea
              v-model="$v.data_agenda.description.$model"
              placeholder="Deskripsi"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Detail Agenda</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_agenda.tahunajaran.$error}">
            <label> Tahun Ajaran </label>
            <j-single-select
              v-model="$v.data_agenda.tahunajaran.$model"
              :options="list_tahun_ajaran"
              :placeholder="'Pilih Tahun Ajaran'"
              :disabled="readOnly"
              value-format="object"
              label="tahunajaran"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_agenda.semester.$error}">
            <label> Semester </label>
            <j-single-select
              v-model="$v.data_agenda.semester.$model"
              :options="list_semester"
              :placeholder="'Pilih Semester'"
              :disabled="readOnly"
              value-format="object"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_agenda.date_time.$error}">
            <label> Tanggal </label>
            <j-datepicker
              v-model="$v.data_agenda.date_time.$model"
              :disabled="readOnly"
              placeholder="Tanggal"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_agenda.description.$error}">
            <label> Deskripsi </label>
            <j-textarea
              v-model="$v.data_agenda.description.$model"
              :disabled="readOnly"
              placeholder="Deskripsi"/>
          </b-form-group>
        </b-col>
      </b-row>

      <hr>
      <b-button
        v-if="list_siswa_absen.length > 0 && !readOnly"
        class="btn grey btn-import-form m__r--5"
        @click="actionInsertAbsen">
        {{ showBtnInsertAbsen ? 'Insert' : 'Update' }}
      </b-button>
      <div
        v-for=" (item, index) in list_siswa_absen"
        :key="index"
        class="list-absen">
        <b-row>
          <b-col
            md="3"
            class="p__t--30">
            {{ item.nis }} <br>
            {{ item.nama_siswa }}
          </b-col>
          <b-col md="2">
            <b-form-radio-group
              v-model="item.status"
              :options="list_status"
              :stacked="true"
              :disabled="readOnly"
              class="jFormGroup"/>
          </b-col>
          <b-col
            md="7"
            class="p__t--30">
            <j-input
              v-model="item.keterangan"
              :disabled="readOnly"
              placeholder="Keterangan"/>
          </b-col>
          <!-- <b-col
            md="1"
            class="p__t--35">
            <i
              v-if="item.id"
              class="fa fa-save fa-2x cursor-pointer"/>
          </b-col> -->
        </b-row>
      </div>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Surat -------------------------------------------------------------------- -->
    <b-modal
      ref="modalCreateSurat"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Surat</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_surat.type.$error}">
            <label> Type </label>
            <j-single-select
              v-model="$v.data_surat.type.$model"
              :options="list_type"
              :placeholder="'Pilih Type'"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_surat.tahunajaran.$error}">
            <label> Tahun Ajaran </label>
            <j-single-select
              v-model="$v.data_surat.tahunajaran.$model"
              :options="list_tahun_ajaran"
              :placeholder="'Pilih Tahun Ajaran'"
              value-format="object"
              label="tahunajaran"
              @getData="setDataAnggota"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_surat.semester.$error}">
            <label> Semester </label>
            <j-single-select
              v-model="$v.data_surat.semester.$model"
              :options="list_semester"
              :placeholder="'Pilih Semester'"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_surat.title.$error}">
            <label> Title </label>
            <j-input
              v-model="$v.data_surat.title.$model"
              placeholder="Title"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_surat.attachment.$error}">
            <label> File </label><br>
            <j-singleupload
              v-model="$v.data_surat.attachment.$model"
              :accepted-file-type="['xls', 'xlsx', 'docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_surat.attachment.$model"
              :url-upload="url_upload"
              @url="getUrl"/>
            <label>
              Please choose file with supported format file
              xls, xlsx, docx, doc, pdf, jpg, png, jpeg.
            </label>
          </b-form-group>

          <j-form-base
            v-if="showAdditionalInfo"
            ref="jFormCreate"
            :data-fields="dataFields"/>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveDataSurat">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreateSurat">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdateSurat"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Surat</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_surat.type.$error}">
            <label> Type </label>
            <j-single-select
              v-model="$v.data_surat.type.$model"
              :options="list_type"
              :placeholder="'Pilih Type'"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_surat.tahunajaran.$error}">
            <label> Tahun Ajaran </label>
            <j-single-select
              v-model="$v.data_surat.tahunajaran.$model"
              :options="list_tahun_ajaran"
              :placeholder="'Pilih Tahun Ajaran'"
              value-format="object"
              label="tahunajaran"
              @getData="setDataAnggotaUpdate"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_surat.semester.$error}">
            <label> Semester </label>
            <j-single-select
              v-model="$v.data_surat.semester.$model"
              :options="list_semester"
              :placeholder="'Pilih Semester'"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_surat.title.$error}">
            <label> Title </label>
            <j-input
              v-model="$v.data_surat.title.$model"
              placeholder="Title"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_surat.attachment.$error}">
            <label> File </label><br>
            <j-singleupload
              v-model="$v.data_surat.attachment.$model"
              :accepted-file-type="['xls', 'xlsx', 'docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_surat.attachment.$model"
              :url-upload="url_upload"
              @url="getUrl"/>
            <label>
              Please choose file with supported format file
              xls, xlsx, docx, doc, pdf, jpg, png, jpeg.
            </label>
          </b-form-group>

          <j-form-base
            v-if="showAdditionalInfo"
            ref="jFormUpdate"
            :data-fields="dataFields"
            :is-detail="true"
            :is-disabled="false"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <b-button
            class="btn red m__t--20"
            @click="deleteDataSurat">
            Delete
          </b-button>
        </b-col>
        <b-col md="9">
          <div class="float-to-right m__t--20">
            <b-button
              class="btn green m__r--5"
              @click="submitDataSurat">
              Submit
            </b-button>
            <b-button
              class="btn blue m__r--5"
              @click="updateDataSurat">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdateSurat">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import Vue from 'vue';
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jFormBase from '@/views/kurikulum/additional-info/jFormBase';
import jProgressScreen from '@/components/progress-screen/jProgressScreen';

export default {
  components: {
    jLoadingTable,
    jFormBase,
    jProgressScreen,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Detail Data Ekstrakulikuler',
      },

      data_master: {
        id: '',
        kode: '',
        name: '',
        status: '',
      },
      list_status_ekskul: [
        {
          id: 'Aktif',
          name: 'Aktif',
        },
        {
          id: 'Tidak Aktif',
          name: 'Tidak Aktif',
        },
      ],
      tabSelected: 'general',

      // Pembina ----------------------------------------------------
      data_pembina: {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: null,
        kode_pegawai: null,
        notes: '',
      },
      list_pegawai: [],

      list_pembina: [],
      columns_pembina: ['kode', 'kode_pegawai', 'nama_pegawai', 'tahunajaran'],
      options_pembina: {
        headings: {
          kode: 'Kode Ekskul',
          kode_pegawai: 'Kode Pegawai',
          nama_pegawai: 'Nama Pegawai',
          tahunajaran: 'Tahun Ajaran',
        },
        sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
        sortable: [],
        filterable: false,
      },

      // Anggota ----------------------------------------------------
      list_kelas: [],
      list_siswa_by_kelas: [],
      data_anggota: {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: null,
        kode_kelas: null,
        nis: null,
      },
      data_anggota_detail: null,
      tahunajaranAnggota: null,

      list_anggota: [],
      columns_anggota: ['kode', 'kode_kelas', 'nama_kelas', 'nis', 'nama_siswa', 'tahunajaran'],
      options_anggota: {
        headings: {
          kode: 'Kode Ekskul',
          kode_kelas: 'Kode Kelas',
          nama_kelas: 'Nama Kelas',
          nis: 'NIS',
          nama_siswa: 'Nama Siswa',
          tahunajaran: 'Tahun Ajaran',
        },
        sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
        sortable: [],
        filterable: false,
      },

      openImportAnggota: true,
      data_import_anggota: null,
      list_error_anggota: [],
      error_data_anggota: [],
      is_error_anggota: false,

      columns_error_anggota: ['KODE_KELAS', 'NIS', 'ERROR'],
      options_error_anggota: {
        headings: {
          KODE_KELAS: 'KODE KELAS',
          NIS: 'NIS',
          ERROR: 'ERROR',
        },
        sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
        sortable: [],
        filterable: false,
      },

      // Agenda ----------------------------------------------------
      data_agenda: {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: null,
        semester: null,
        date_time: null,
        description: '',
      },
      showBtnInsertAbsen: false,
      list_tahun_ajaran: [],
      list_siswa_absen: [],
      list_semester: [
        { id: 'ganjil', name: 'Ganjil' },
        { id: 'genap', name: 'Genap' },
      ],
      list_status: [
        {
          value: 'hadir',
          text: 'Hadir',
        },
        {
          value: 'sakit',
          text: 'Sakir',
        },
        {
          value: 'ijin',
          text: 'Ijin',
        },
        {
          value: 'alfa',
          text: 'Alfa',
        },
      ],

      list_agenda: [],
      columns: ['kode_ekskul', 'nama_ekskul', 'description', 'date_time', 'tahunajaran', 'semester'],
      options: {
        headings: {
          kode_ekskul: 'Kode Ekskul',
          nama_ekskul: 'Nama Ekskul',
          description: 'Deskripsi',
          date_time: 'Tanggal',
          tahunajaran: 'Tahun Ajaran',
          semester: 'Semester',
        },
        sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
        sortable: [],
        filterable: false,
      },

      // Nilai ----------------------------------------------------
      tahun_ajaran_nilai: null,
      semester_nilai: null,
      list_siswa_nilai: [],
      list_nilai: [
        { id: 'A', name: 'A' },
        { id: 'B', name: 'B' },
        { id: 'C', name: 'C' },
        { id: 'D', name: 'D' },
      ],
      modeUpdateNilai: false,

      openImportNilai: true,
      data_import_nilai: null,
      list_error_nilai: [],
      error_data_nilai: [],
      is_error_nilai: false,

      columns_error_nilai: ['KODE_KELAS', 'NAMA_KELAS', 'NIS', 'NAMA_SISWA', 'NILAI', 'ERROR'],
      options_error_nilai: {
        headings: {
          KODE_KELAS: 'KODE KELAS',
          NAMA_KELAS: 'NAMA KELAS',
          NIS: 'NIS',
          NAMA_SISWA: 'NAMA SISWA',
          NILAI: 'NILAI',
          ERROR: 'ERROR',
        },
        sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
        sortable: [],
        filterable: false,
      },

      // Surat ----------------------------------------------------
      data_surat: {
        nis: '',
        type: null,
        title: '',
        semester: null,
        category_id: '11',
        attachment: null,
        additional_info: [],
        tahunajaran: null,
        kode_kelas: null,
        kode_ekskul: this.$route.params.kode,
      },
      list_type: [
        { id: 'Dispensasi', name: 'Dispensasi' },
      ],
      token: (JSON.parse(localStorage.getItem('Token'))).value,
      dataFields: [],
      showAdditionalInfo: false,
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns_surat: ['id', 'title', 'tahunajaran', 'semester', 'kode_kelas', 'category_name', 'created_date', 'updated_date'],
      options_surat: {
        headings: {
          id: 'ID',
          title: 'TITLE',
          tahunajaran: 'TAHUN AJARAN',
          semester: 'SEMESTER',
          kode_kelas: 'KODE KELAS',
          category_name: 'KATEGORI',
          created_date: 'CREATED',
          updated_date: 'UPDATED',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            status: 'draft',
            module_id: 6,
            category_id: 11,
            nis: '',
            limit: data.limit,
            page: data.page,
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.getListDocument(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
    url_upload() {
      return `${process.env.GATE_URL}file/upload`;
    },

    headers() {
      const token = Vue.ls.get('Token');
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      return headers;
    },
  },
  watch: {
  },
  created() {
    this.getDetailEkskul();
    this.listTahunAjaran();
    this.listPegawai();
    this.listAgenda();
    this.listPembina();
    this.getDataAdditionalInfo();
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['getListPegawai']),
    ...mapActions('jStoreKesiswaan', [
      'updateEkskul', 'deleteEkskul', 'detailEkskul',
      'getListAgenda', 'createAgenda', 'updateAgenda', 'deleteAgenda',
      'getListPembina', 'createPembina', 'updatePembina', 'deletePembina',
      'getListAnggota', 'createAnggota', 'updateAnggota', 'deleteAnggota',
      'getListAbsen', 'insertAbsen', 'updateAbsen',
      'getListNilai', 'insertNilai', 'updateNilai',
      'getAdditionalInfo', 'createDocument', 'updateDocument', 'detailDocument', 'deleteDocument', 'submitDocument',
      'getListTahunAjaran', 'getListKelas', 'getListSiswaByKelas',
    ]),

    loadOptionsSiswa({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              query: searchQuery,
              query_type: 'nama_siswa',
            },
          };
          this.$store.dispatch('jStoreKesiswaan/getListSiswaAsync', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    getDetailEkskul() {
      const paramEkskul = { kode_ekskul: this.$route.params.kode };
      this.detailEkskul(paramEkskul).then((res) => {
        const dataDetail = res.data.data;
        this.data_master.id = dataDetail.id;
        this.data_master.kode = dataDetail.kode;
        this.data_master.name = dataDetail.name;
        this.data_master.status = dataDetail.status;
      });
    },

    listTahunAjaran() {
      const paramTahunAjaran = {
        pagination: {
          query: '',
          query_type: '',
        },
      };
      this.getListTahunAjaran(paramTahunAjaran).then((res) => {
        this.list_tahun_ajaran = res.data.data;
      });
    },

    listPegawai() {
      this.getListPegawai().then((res) => {
        this.list_pegawai = res.data.data;
      });
    },

    selectTab(status) {
      this.tabSelected = status;
    },

    getDataAdditionalInfo() {
      this.getAdditionalInfo(11).then((res) => {
        this.dataFields = res.data.data.map(el => ({
          id: el.id,
          name: el.field_name,
          type: el.type,
          placeholder: el.placeholder,
          field_key: el.field_key,
          is_delete: false,
          is_editable: false,
          is_mandatory: false,
          // config: el.type === 'multiple_selection_anggota_ekskul' ? {
          //   kode_ekskul: this.$route.params.kode,
          //   tahunajaran: '',
          // } : null,
        }));
      });
    },

    // Ekskul ----------------------------------------------------
    updateDataEkskul() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const param = this.data_master;
        this.updateEkskul(param).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$router.push('/data-ekskul');
            }, 1500);
          }
        });
      }
    },

    deleteDataEkskul() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteEkskul(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$router.push('/data-ekskul');
              }, 1500);
            }
          });
        }
      });
    },

    // Pembina ----------------------------------------------------
    listPembina() {
      const paramPembina = {
        kode_ekskul: this.$route.params.kode,
        limit: 200,
        page: 1,
      };
      this.getListPembina(paramPembina).then((res) => {
        this.list_pembina = res.data.data;
      });
    },

    closeModalCreatePembina() {
      this.$refs.modalCreatePembina.hide();
      this.data_pembina = {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: null,
        kode_pegawai: null,
        notes: '',
      };
      setTimeout(() => {
        this.$v.data_pembina.$reset();
      }, 1000);
    },

    closeModalUpdatePembina() {
      this.$refs.modalUpdatePembina.hide();
      this.data_pembina = {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: null,
        kode_pegawai: null,
        notes: '',
      };
      setTimeout(() => {
        this.$v.data_pembina.$reset();
      }, 1000);
    },

    openEditModalPembina(param) {
      this.$refs.modalUpdatePembina.show();
      const tahunajaranSelected = this.list_tahun_ajaran.find(f => f.tahunajaran === param.row.tahunajaran);
      const pegawaiSelected = this.list_pegawai.find(f => f.kode_pegawai === param.row.kode_pegawai);
      this.data_pembina = {
        id: param.row.id,
        kode_ekskul: this.$route.params.kode,
        tahunajaran: tahunajaranSelected || null,
        kode_pegawai: pegawaiSelected || null,
        notes: param.row.notes,
      };
    },

    saveDataPembina() {
      this.$v.data_pembina.$touch();
      if (!this.$v.data_pembina.$error) {
        const params = {
          kode_ekskul: this.data_pembina.kode_ekskul,
          tahunajaran: this.data_pembina.tahunajaran ? this.data_pembina.tahunajaran.tahunajaran : '',
          kode_pegawai: this.data_pembina.kode_pegawai ? this.data_pembina.kode_pegawai.kode_pegawai : '',
        };
        this.createPembina(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.listPembina();
              this.closeModalCreatePembina();
            }, 1500);
          }
        });
      }
    },

    updateDataPembina() {
      this.$v.data_pembina.$touch();
      if (!this.$v.data_pembina.$error) {
        const params = this.data_pembina;
        params.tahunajaran = params.tahunajaran ? params.tahunajaran.tahunajaran : '';
        params.kode_pegawai = params.kode_pegawai ? params.kode_pegawai.kode_pegawai : '';
        this.updatePembina(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.listPembina();
              this.closeModalUpdatePembina();
            }, 1500);
          }
        });
      }
    },

    deleteDataPembina() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_pembina.id,
          };
          this.deletePembina(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.listPembina();
                this.closeModalUpdatePembina();
              }, 1500);
            }
          });
        }
      });
    },

    // Anggota ----------------------------------------------------
    listAnggota(param) {
      this.showLoading();
      const paramAnggota = {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: param,
      };
      this.getListAnggota(paramAnggota).then((res) => {
        this.hideLoading();
        this.list_anggota = res.data.data;
      });
    },

    getDataKelas() {
      const params = {
        pagination: {
          query: this.data_anggota.tahunajaran.tahunajaran,
          query_type: 'tahunajaran',
        },
      };
      this.getListKelas(params).then((res) => {
        this.list_kelas = res.data.data;
        if (this.data_anggota_detail) {
          const kelasSelected = this.list_kelas.find(f => f.kode === this.data_anggota_detail.kode_kelas);
          this.data_anggota.kode_kelas = kelasSelected || null;
        }
      });
    },

    getDataSiswa() {
      const params = {
        kode_kelas: this.data_anggota.kode_kelas.kode,
        tahunajaran: this.data_anggota.tahunajaran.tahunajaran,
      };
      this.getListSiswaByKelas(params).then((res) => {
        this.list_siswa_by_kelas = res.data.data;
        if (this.data_anggota_detail) {
          const siswaSelected = this.list_siswa_by_kelas.find(f => f.nis === this.data_anggota_detail.nis);
          this.data_anggota.nis = siswaSelected || null;
        }
      });
    },

    closeModalCreateAnggota() {
      this.$refs.modalCreateAnggota.hide();
      this.data_anggota = {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: null,
        kode_kelas: null,
        nis: null,
      };
      setTimeout(() => {
        this.$v.data_anggota.$reset();
      }, 1000);
    },

    closeModalUpdateAnggota() {
      this.$refs.modalUpdateAnggota.hide();
      this.data_anggota_detail = null;
      this.data_anggota = {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: null,
        kode_kelas: null,
        nis: null,
      };
      setTimeout(() => {
        this.$v.data_anggota.$reset();
      }, 1000);
    },

    openEditModalAnggota(param) {
      this.$refs.modalUpdateAnggota.show();
      this.data_anggota_detail = param.row;
      const tahunajaranSelected = this.list_tahun_ajaran.find(f => f.tahunajaran === param.row.tahunajaran);
      this.data_anggota = {
        id: param.row.id,
        kode_ekskul: this.$route.params.kode,
        tahunajaran: tahunajaranSelected || null,
        kode_kelas: null,
        nis: null,
      };
    },

    saveDataAnggota() {
      this.$v.data_anggota.$touch();
      if (!this.$v.data_anggota.$error) {
        const params = this.data_anggota;
        params.tahunajaran = params.tahunajaran ? params.tahunajaran.tahunajaran : '';
        params.kode_kelas = params.kode_kelas ? params.kode_kelas.kode : '';
        params.nis = params.nis ? params.nis.nis : '';
        this.createAnggota(params).then((res) => {
          if (!res.data.error) {
            this.tahunajaranAnggota = this.list_tahun_ajaran.find(f => f.tahunajaran === params.tahunajaran);
            setTimeout(() => {
              this.listAnggota(params.tahunajaran);
              this.closeModalCreateAnggota();
            }, 1500);
          }
        });
      }
    },

    updateDataAnggota() {
      this.$v.data_anggota.$touch();
      if (!this.$v.data_anggota.$error) {
        const params = this.data_anggota;
        params.tahunajaran = params.tahunajaran ? params.tahunajaran.tahunajaran : '';
        params.kode_kelas = params.kode_kelas ? params.kode_kelas.kode : '';
        params.nis = params.nis ? params.nis.nis : '';
        this.updateAnggota(params).then((res) => {
          if (!res.data.error) {
            this.tahunajaranAnggota = this.list_tahun_ajaran.find(f => f.tahunajaran === params.tahunajaran);
            setTimeout(() => {
              this.listAnggota(params.tahunajaran);
              this.closeModalUpdateAnggota();
            }, 1500);
          }
        });
      }
    },

    deleteDataAnggota() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_anggota.id,
          };
          this.deleteAnggota(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.listAnggota(this.tahunajaranAnggota.tahunajaran);
                this.closeModalUpdateAnggota();
              }, 1500);
            }
          });
        }
      });
    },

    importDataAnggota(val) {
      const keys = Object.keys(val[0]);
      if (keys[0] !== 'KODE_KELAS' || keys[1] !== 'NIS') {
        this.toggleProblem('Please use header format correctly');
      }
      this.is_error_anggota = false;
      this.list_error_anggota = [];
      this.error_data_anggota = val;
      const fileData = val;
      const genData = [];
      fileData.forEach((e, index) => {
        const ccData = this.convertDataAnggota(e, index);
        if (ccData !== false) {
          genData.push(ccData);
        }
      });
      this.data_import_anggota = genData;

      setTimeout(() => {
        if (this.data_import_anggota && !this.is_error_anggota) {
          this.$refs.ImportFileAnggota.toggleIsVisible();
        }
      }, 1000);
    },

    convertDataAnggota(val, indexData) {
      this.list_error_anggota[indexData] = [];
      this.error_data_anggota[indexData].ERROR = [];
      const packing = {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: this.tahunajaranAnggota.tahunajaran,
        kode_kelas: val.KODE_KELAS,
        nis: val.NIS,
      };
      if (!val.KODE_KELAS) {
        this.is_error_anggota = true;
        this.list_error_anggota[indexData].push('KODE_KELAS tidak boleh kosong');
        this.error_data_anggota[indexData].ERROR.push('KODE_KELAS tidak boleh kosong');
      }
      if (!val.NIS) {
        this.is_error_anggota = true;
        this.list_error_anggota[indexData].push('NIS tidak boleh kosong');
        this.error_data_anggota[indexData].ERROR.push('NIS tidak boleh kosong');
      }
      return packing;
    },

    reloadPageAnggota() {
      this.listAnggota(this.tahunajaranAnggota.tahunajaran);
      this.openImportAnggota = false;
      this.data_import_anggota = null;
      this.list_error_anggota = [];
      this.error_data_anggota = [];
      this.is_error_anggota = false;
      setTimeout(() => {
        this.openImportAnggota = true;
      }, 500);
    },

    // Agenda ----------------------------------------------------
    listAgenda() {
      const paramAgenda = {
        kode_ekskul: this.$route.params.kode,
        limit: 1000000,
        page: 1,
      };
      this.getListAgenda(paramAgenda).then((res) => {
        this.list_agenda = res.data.data;
      });
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_agenda = {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: null,
        semester: null,
        date_time: null,
        description: '',
      };
      setTimeout(() => {
        this.$v.data_agenda.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_agenda = {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: null,
        semester: null,
        date_time: null,
        description: '',
      };
      setTimeout(() => {
        this.$v.data_agenda.$reset();
      }, 1000);
    },

    openEditModalAgenda(param) {
      this.list_siswa_absen = [];
      this.showBtnInsertAbsen = false;

      const paramAbsen = {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: param.row.tahunajaran,
        semester: param.row.semester,
        id_ekskul_agenda: param.row.id,
      };
      this.getListAbsen(paramAbsen).then((res) => {
        if (res.data.data.length > 0) {
          this.list_siswa_absen = res.data.data.map(el => ({
            id: el.id,
            kode_ekskul: el.kode,
            kode_kelas: el.kode_kelas,
            nama_kelas: el.nama_kelas,
            nama_siswa: el.nama_siswa,
            nis: el.nis,
            tahunajaran: el.tahunajaran,
            semester: el.semester,
            id_ekskul_agenda: param.row.id || 0,
            date_time: el.date_time,
            status: el.status || null,
            keterangan: el.keterangan || null,
          }));
        } else {
          this.showBtnInsertAbsen = true;
          const paramAnggota = {
            kode_ekskul: this.$route.params.kode,
            tahunajaran: param.row.tahunajaran,
          };
          this.getListAnggota(paramAnggota).then((resAng) => {
            this.list_siswa_absen = resAng.data.data.map(el => ({
              kode_ekskul: el.kode,
              kode_kelas: el.kode_kelas,
              nama_kelas: el.nama_kelas,
              nama_siswa: el.nama_siswa,
              nis: el.nis,
              tahunajaran: el.tahunajaran,
              semester: param.row.semester ? param.row.semester : null,
              id_ekskul_agenda: param.row.id ? param.row.id : 0,
              date_time: param.row.date_time,
              status: null,
              keterangan: null,
            }));
          });
        }
      });

      this.$refs.modalUpdate.show();
      const tahunajaranSelected = this.list_tahun_ajaran.find(f => f.tahunajaran === param.row.tahunajaran);
      this.data_agenda = {
        id: param.row.id ? param.row.id : 0,
        kode_ekskul: param.row.kode_ekskul,
        tahunajaran: tahunajaranSelected || null,
        semester: param.row.semester ? { id: param.row.semester } : null,
        date_time: param.row.date_time,
        description: param.row.description,
      };
    },

    saveData() {
      this.$v.data_agenda.$touch();
      if (!this.$v.data_agenda.$error) {
        const params = this.data_agenda;
        params.tahunajaran = params.tahunajaran ? params.tahunajaran.tahunajaran : '';
        params.semester = params.semester ? params.semester.id : '';
        params.date_time = params.date_time ? this.$moment(params.date_time).format('YYYY-MM-DD HH:mm') : '';
        this.createAgenda(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.listAgenda();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_agenda.$touch();
      if (!this.$v.data_agenda.$error) {
        const params = this.data_agenda;
        params.tahunajaran = params.tahunajaran ? params.tahunajaran.tahunajaran : '';
        params.semester = params.semester ? params.semester.id : '';
        params.date_time = params.date_time ? this.$moment(params.date_time).format('YYYY-MM-DD HH:mm') : '';
        this.updateAgenda(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.listAgenda();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_agenda.id,
          };
          this.deleteAgenda(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.listAgenda();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },

    // Absen ----------------------------------------------------
    actionInsertAbsen() {
      const params = this.list_siswa_absen;
      const action = this.showBtnInsertAbsen ? 'insertAbsen' : 'updateAbsen';
      this[action](params).then((res) => {
        if (!res.data.error) {
          setTimeout(() => {
            this.listAgenda();
            this.closeModalUpdate();
          }, 1500);
        }
      });
    },

    // Nilai ----------------------------------------------------
    listNilaiAnggota() {
      this.showLoading();
      const paramNilai = {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: this.tahun_ajaran_nilai.tahunajaran,
        semester: this.semester_nilai.id,
      };
      this.getListNilai(paramNilai).then((res) => {
        if (res.data.data.length > 0) {
          this.hideLoading();
          this.modeUpdateNilai = true;
          this.list_siswa_nilai = res.data.data.map(el => ({
            id: el.id,
            kode_ekskul: el.kode_ekskul || this.$route.params.kode,
            kode_kelas: el.kode_kelas,
            nama_kelas: el.nama_kelas,
            nama_siswa: el.nama_siswa,
            nis: el.nis,
            tahunajaran: el.tahunajaran || this.tahun_ajaran_nilai.tahunajaran,
            semester: el.semester || this.semester_nilai.id,
            nilai: el.nilai || null,
          }));
        } else {
          this.modeUpdateNilai = false;
          const paramAnggota = {
            kode_ekskul: this.$route.params.kode,
            tahunajaran: this.tahun_ajaran_nilai.tahunajaran,
          };
          this.getListAnggota(paramAnggota).then((resAng) => {
            this.hideLoading();
            this.list_siswa_nilai = resAng.data.data.map(el => ({
              kode_ekskul: el.kode || this.$route.params.kode,
              kode_kelas: el.kode_kelas,
              nama_kelas: el.nama_kelas,
              nama_siswa: el.nama_siswa,
              nis: el.nis,
              tahunajaran: el.tahunajaran || this.tahun_ajaran_nilai.tahunajaran,
              semester: this.semester_nilai ? this.semester_nilai.id : null,
              nilai: null,
            }));
          });
        }
      });
    },

    actionInsertNilai() {
      const params = this.list_siswa_nilai;
      const action = this.modeUpdateNilai ? 'updateNilai' : 'insertNilai';
      this[action](params).then((res) => {
        if (!res.data.error) {
          setTimeout(() => {
            this.list_siswa_nilai = [];
          }, 1500);
        }
      });
    },

    importDataNilai(val) {
      const keys = Object.keys(val[0]);
      if (keys[0] !== 'KODE_KELAS' ||
        keys[1] !== 'NAMA_KELAS' ||
        keys[2] !== 'NIS' ||
        keys[3] !== 'NAMA_SISWA' ||
        keys[4] !== 'NILAI') {
        this.toggleProblem('Please use header format correctly');
      }
      this.is_error_nilai = false;
      this.list_error_nilai = [];
      this.error_data_nilai = val;
      const fileData = val;
      const genData = [];
      fileData.forEach((e, index) => {
        const ccData = this.convertDataNilai(e, index);
        if (ccData !== false) {
          genData.push(ccData);
        }
      });
      this.data_import_nilai = genData;

      setTimeout(() => {
        if (this.data_import_nilai && !this.is_error_nilai) {
          this.$refs.ImportFileNilai.toggleIsVisible();
        }
      }, 1000);
    },

    convertDataNilai(val, indexData) {
      this.list_error_nilai[indexData] = [];
      this.error_data_nilai[indexData].ERROR = [];
      const packing = {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: this.tahun_ajaran_nilai.tahunajaran,
        semester: this.semester_nilai.id,
        kode_kelas: val.KODE_KELAS,
        nama_kelas: val.NAMA_KELAS,
        nis: val.NIS,
        nama_siswa: val.NAMA_SISWA,
        nilai: val.NILAI,
      };
      if (!val.KODE_KELAS) {
        this.is_error_nilai = true;
        this.list_error_nilai[indexData].push('KODE_KELAS tidak boleh kosong');
        this.error_data_nilai[indexData].ERROR.push('KODE_KELAS tidak boleh kosong');
      }
      if (!val.NAMA_KELAS) {
        this.is_error_nilai = true;
        this.list_error_nilai[indexData].push('NAMA_KELAS tidak boleh kosong');
        this.error_data_nilai[indexData].ERROR.push('NAMA_KELAS tidak boleh kosong');
      }
      if (!val.NIS) {
        this.is_error_nilai = true;
        this.list_error_nilai[indexData].push('NIS tidak boleh kosong');
        this.error_data_nilai[indexData].ERROR.push('NIS tidak boleh kosong');
      }
      if (!val.NAMA_SISWA) {
        this.is_error_nilai = true;
        this.list_error_nilai[indexData].push('NAMA_SISWA tidak boleh kosong');
        this.error_data_nilai[indexData].ERROR.push('NAMA_SISWA tidak boleh kosong');
      }
      if (!val.NILAI) {
        this.is_error_nilai = true;
        this.list_error_nilai[indexData].push('NILAI tidak boleh kosong');
        this.error_data_nilai[indexData].ERROR.push('NILAI tidak boleh kosong');
      }
      return packing;
    },

    reloadPageNilai() {
      this.listNilaiAnggota();
      this.openImportNilai = false;
      this.data_import_nilai = null;
      this.list_error_nilai = [];
      this.error_data_nilai = [];
      this.is_error_nilai = false;
      setTimeout(() => {
        this.openImportNilai = true;
      }, 500);
    },

    // Surat ----------------------------------------------------
    getUrl(data) {
      this.data_surat.attachment = data;
    },

    loading(val) {
      const a = val;
      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreateSurat() {
      this.$refs.modalCreateSurat.hide();
      this.showAdditionalInfo = false;
      this.data_surat = {
        nis: '',
        type: null,
        title: '',
        semester: null,
        category_id: '11',
        attachment: null,
        additional_info: [],
        tahunajaran: null,
        kode_kelas: null,
        kode_ekskul: this.$route.params.kode,
      };
      setTimeout(() => {
        this.$v.data_surat.$reset();
      }, 1000);
    },

    closeModalUpdateSurat() {
      this.$refs.modalUpdateSurat.hide();
      this.showAdditionalInfo = false;
      this.data_surat = {
        nis: '',
        type: null,
        title: '',
        semester: null,
        category_id: '11',
        attachment: null,
        additional_info: [],
        tahunajaran: null,
        kode_kelas: null,
        kode_ekskul: this.$route.params.kode,
      };
      setTimeout(() => {
        this.$v.data_surat.$reset();
      }, 1000);
    },

    openEditModalSurat(param) {
      this.$refs.modalUpdateSurat.show();

      const params = {
        id: param.row.id,
      };
      this.detailDocument(params).then((res) => {
        const tahunajaranSelected = this.list_tahun_ajaran.find(f => f.tahunajaran === param.row.tahunajaran);
        this.data_surat = {
          id: param.row.id,
          nis: '',
          type: 'Dispensasi',
          semester: param.row.semester,
          title: param.row.title,
          category_id: '11',
          attachment: param.row.attachment,
          additional_info: [],
          tahunajaran: tahunajaranSelected || null,
          kode_kelas: null,
          kode_ekskul: this.$route.params.kode,
        };
        this.dataFields = res.data.data.additional_info.map(el => ({
          id: el.id,
          name: el.field_name,
          type: el.type,
          placeholder: el.placeholder,
          field_key: el.field_key,
          value: el.value,
          is_delete: false,
          is_editable: false,
          is_mandatory: false,
        }));
        this.showAdditionalInfo = true;
      });
    },

    setDataAnggota() {
      const param = {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: this.data_surat.tahunajaran.tahunajaran,
      };
      this.$refs.jFormCreate.setParamTahunAjaran(param);
    },

    saveDataSurat() {
      this.$v.data_surat.$touch();
      if (!this.$v.data_surat.$error) {
        this.$refs.jFormCreate.getData().then((params) => {
          this.data_surat.tahunajaran = this.data_surat.tahunajaran ? this.data_surat.tahunajaran.tahunajaran : '';
          this.data_surat.additional_info = params.map(e => ({
            field_key: e.field_key,
            value: e.value,
          }));
          this.createDocument(this.data_surat).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalCreateSurat();
              }, 1500);
            }
          });
        });
      }
    },

    setDataAnggotaUpdate() {
      const param = {
        kode_ekskul: this.$route.params.kode,
        tahunajaran: this.data_surat.tahunajaran.tahunajaran,
      };
      this.$refs.jFormUpdate.setParamTahunAjaran(param);
    },

    updateDataSurat() {
      this.$v.data_surat.$touch();
      if (!this.$v.data_surat.$error) {
        this.$refs.jFormUpdate.getData().then((params) => {
          this.data_surat.tahunajaran = this.data_surat.tahunajaran ? this.data_surat.tahunajaran.tahunajaran : '';
          this.data_surat.additional_info = params.map(e => ({
            field_key: e.field_key,
            value: e.value,
          }));
          this.updateDocument(this.data_surat).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdateSurat();
              }, 1500);
            }
          });
        });
      }
    },

    deleteDataSurat() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_surat.id,
          };
          this.deleteDocument(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdateSurat();
              }, 1500);
            }
          });
        }
      });
    },

    submitDataSurat() {
      this.$swal({
        title: 'Submit Data',
        text: 'Are you sure want to submit this data?',
        showCancelButton: true,
        confirmButtonText: 'Submit',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_surat.id,
          };
          this.submitDocument(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdateSurat();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        id: { required },
        kode: { required },
        name: { required },
        status: { required },
      },
      data_pembina: {
        kode_ekskul: { },
        tahunajaran: { required },
        kode_pegawai: { required },
        notes: { },
      },
      data_anggota: {
        kode_ekskul: { },
        tahunajaran: { required },
        kode_kelas: { required },
        nis: { required },
      },
      tahunajaranAnggota: { },
      data_agenda: {
        kode_ekskul: { },
        tahunajaran: { required },
        semester: { required },
        date_time: { required },
        description: { required },
      },
      tahun_ajaran_nilai: { },
      semester_nilai: { },
      data_surat: {
        semester: { required },
        title: { required },
        attachment: { },
        tahunajaran: { },
        type: { },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
  .list-absen {
    background-color: #f9f9f9;
    border-radius: 10px;
    margin: 8px 0;
    padding: 4px 8px;
    font-family: "Gotham-Book" !important;
    font-size: 12px;
  }

  .list-nilai {
    width: 50%;
    background-color: #f9f9f9;
    border-radius: 10px;
    margin: 8px 0;
    padding: 4px 8px;
    font-family: "Gotham-Book" !important;
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/views/kesiswaan/ekskul/jEkskulUpdate.vue